import { syncValidateData } from '../../../common/validator';
import { customer as customerSchema } from '../../../common/validation/schemas';
import { capitalize } from 'lodash';
import { USER_TYPES } from '../../../auth/constants';

// eslint-disable-next-line import/prefer-default-export
export const validate = values => syncValidateData(values, customerSchema);

const getCustomerBlockedStatus = ({
  userKind,
  customer,
  barberId,
  shopId,
  brandId,
}) => {
  const levels = [
    {
      kind: 'brand',
      id: brandId,
    },
    {
      kind: 'shop',
      id: (userKind === USER_TYPES.shop || userKind === USER_TYPES.barber) ? shopId : null,
    },
    {
      kind: 'barber',
      id: userKind === USER_TYPES.barber ? barberId : null,
    },
  ].filter(({ id }) => !!id);

  const blockLevel = levels
        .find(({ kind, id }) =>
            (customer[`blocked${capitalize(kind)}s`] || []).some(entity => entity.id === id)
        );

  return blockLevel ? { isBlocked: true, blockKind: blockLevel.kind } : { isBlocked: false };
};

export const canChangeCustomerBlockStatus = ({
    userKind,
    customer,
    barberId,
    shopId,
    brandId,
}) => {
  if (userKind === USER_TYPES.brand) {
    return true;
  }

  const { blockKind, isBlocked } = getCustomerBlockedStatus({ userKind, customer, barberId, shopId, brandId });

  if (!isBlocked) {
    return true;
  }

  if (userKind === USER_TYPES.shop) {
    return blockKind !== 'brand';
  }

  if (userKind === USER_TYPES.barber) {
    return blockKind !== 'brand' && blockKind !== 'shop';
  }

  return false;
};

export const isCustomerBlockedFromBooking = ({
    userKind,
    customer,
    barberId,
    shopId,
    brandId,
}) => getCustomerBlockedStatus({
  userKind,
  customer,
  barberId,
  shopId,
  brandId,
}).isBlocked;
